import axios from 'axios';
import qs from 'qs';
import { log } from 'util';
import { Message } from 'element-ui';
import router from '../router'

// 登录请求方法---接口没有使用
const loginreq = (method, url, params) => {
  return axios({
    method: method,
    url: url,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: params,
    traditional: true,
    transformRequest: [
      function (data) {
        let ret = ''
        for (let it in data) {
          ret +=
            encodeURIComponent(it) +
            '=' +
            encodeURIComponent(data[it]) +
            '&'
        }
        return ret
      }
    ]
  }).then((res) => {
    if (res.data.code == "2001") {
      sessionStorage.clear();
      localStorage.clear();
      router.replace('/login');
      Message.error({
        message: res.data.msg,
        duration: 1500
      })
    } else {
      return res.data
    }
  });
};

//线上
const baseUrl = 'https://b2b.naturehike.cn/camp'

// 测试环境
// const baseUrl = 'http://171.168.1.207:8080/camp'

// 自定义post请求
const reqPost = (url, data) => {
  // console.log(url, data, "data-post-----");
  let userInfo = JSON.parse(localStorage.getItem("userdata"));
  if (userInfo) {
    if(data!==undefined){
      data.accountingCompanyCode = userInfo.accountingCompanyCode;
    }
  }
  return axios({
    method: 'post',
    url: baseUrl + url,
    headers: {
      'Content-Type': 'application/json',
      token: localStorage.getItem('logintoken')
    },
    data: data,
  }).then((res) => {
    if (res.data.code == "2001") {
      sessionStorage.clear();
      localStorage.clear();
      router.replace('/login');
      Message.error({
        message: res.data.msg,
        duration: 1500
      })
    } else {
      return res.data
    }
  })
};


// 使用于参数JSON.stringify,不需要加accountingCompanyCode字段
const reqPostString = (url, data) => {
  return axios({
    method: 'post',
    url: baseUrl + url,
    headers: {
      'Content-Type': 'application/json',
      token: localStorage.getItem('logintoken')
    },
    data: data,
  }).then((res) => {
    if (res.data.code == "2001") {
      sessionStorage.clear();
      localStorage.clear();
      router.replace('/login');
      Message.error({
        message: res.data.msg,
        duration: 1500
      })
    } else {
      return res.data
    }
  })
};


// 自定义get请求
const reqMyGet = (url, params) => {
  let userInfo = JSON.parse(localStorage.getItem("userdata"));
  if (userInfo) {
    if (params !== undefined) {
      params.accountingCompanyCode = userInfo.accountingCompanyCode;
    }
  }
  return axios({
    method: 'get',
    url: baseUrl + url,
    headers: {
      'Content-Type': 'application/json',
      token: localStorage.getItem('logintoken')
    },
    data: params,
  }).then((res) => {
    if (res.data.code == "2001") {
      sessionStorage.clear();
      localStorage.clear();
      router.replace('/login');
      Message.error({
        message: res.data.msg,
        duration: 1500
      })
    } else {
      return res.data
    }
  })
};


const req = (method, url, params) => {
  // console.log(url,params,"--------");
  let userInfo = JSON.parse(localStorage.getItem("userdata"));
  if (userInfo) {
    if (params !== undefined) {
      params.accountingCompanyCode = userInfo.accountingCompanyCode;
    }
  }
  return axios({
    method: method,
    url: baseUrl + url,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      token: localStorage.getItem('logintoken')
    },
    data: params,
    traditional: true,
    transformRequest: [
      function (data) {
        let ret = ''
        for (let it in data) {
          ret +=
            encodeURIComponent(it) +
            '=' +
            encodeURIComponent(data[it]) +
            '&'
        }
        return ret
      }
    ]
  }).then((res) => {
    if (res.data.code == "2001") {
      sessionStorage.clear();
      localStorage.clear();
      router.replace('/login');
      Message.error({
        message: res.data.msg,
        duration: 1500
      })
    } else {
      return res.data
    }
  });
};


// 支付公用方式
const alipayReq = (method, url, params) => {
  let userInfo = JSON.parse(localStorage.getItem("userdata"));
  if (userInfo) {
    if(params!==undefined){
      params.accountingCompanyCode = userInfo.accountingCompanyCode;
    }
  }
  return axios({
    method: method,
    url: url,
    headers: {
      'Content-Type': 'application/json',
      // token: localStorage.getItem('logintoken')
    },
    data: params,
    traditional: true
  }).then((res) => {
    if (res.data.code == "2001") {
      sessionStorage.clear();
      localStorage.clear();
      router.replace('/login');
      Message.error({
        message: res.data.msg,
        duration: 1500
      })
    } else {
      return res.data
    }
  });
};


const jsonReq = (method, url, params) => {
  let userInfo = JSON.parse(localStorage.getItem("userdata"));
  if (userInfo) {
    if(params!==undefined){
      params.accountingCompanyCode = userInfo.accountingCompanyCode;
    }
  }
  return axios({
    method: method,
    url: baseUrl + url,
    headers: {
      'Content-Type': 'application/json',
      // token: localStorage.getItem('logintoken')
    },
    data: params,
    traditional: true,
  }).then((res) => {
    if (res.data.code == "2001") {
      sessionStorage.clear();
      localStorage.clear();
      router.replace('/login');
      Message.error({
        message: res.data.msg,
        duration: 1500
      })
    } else {
      return res.data
    }
  });
};

export {
  loginreq,
  req,
  alipayReq,
  reqMyGet,
  jsonReq,
  reqPost,
  reqPostString
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js